import { RiskRating } from "./mda-types";

export const CLAIM_STATUSES = [
  "All statuses",
  "Open",
  "Under Review",
  "Closed",
];

export const RISK_RATINGS: RiskRating[] = ["High", "Medium", "Low"];

export const getRiskColor = (rating: RiskRating) => {
  switch (rating) {
    case "High":
      return "#ed3f48";
    case "Medium":
      return "#f5b52e";
    case "Low":
      return "#2cb856";
    default:
      return "#8290a4";
  }
};
